import React, { useEffect, useRef, useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { InventaireType } from "../../_App/Types/Entites/Inventaire/InventaireType";
import { InventaireSchema } from "../../_App/Schemas/InventaireSchema";
import { Resolver, useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  SelectedOrganisations,
  selectUserId,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { DepotsType } from "../../_App/Types/Entites/DepotsType";
import Select from "react-select";

import {
  ListDepotByOrganisation,
  ListDepots,
  findDepotsByCodeApi,
  findDepotsBySocieteApi,
} from "../../_App/Redux/Slices/depot/depotSlice";
import {
  CalculStockInventaireApi,
  CalculStockInventaireArticleApi,
  Liststockinventaire,
  createInventaireApi,
  importInventaireExcelApi,
  updateInventaireDetailsApi,
} from "../../_App/Redux/Slices/inventaire/inventaireSlice";
import InventaireDetail from "./InventaireDetail";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { formadate } from "../../_App/Helpers/helpers";
import Swal from "sweetalert2";
import { parametrageCaisse } from "../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import {
  findArticleStockByBarCodeApi,
  findArticleStockByRefApi,
} from "../../_App/Redux/Slices/article/articleSlice";
import ArticleListReference from "../../_Layouts/RightBar/RightBar/cart/ArticleListReference";
import { ToastDanger } from "../../Shared/Toasts/ToastDanger";
import {
  findSousCategorieBySociete,
  ListSousCategories,
} from "../../_App/Redux/Slices/souscategories/souscategorieSlice";
import {
  findProductsMarquesApiBySociete,
  ListProductMarques,
} from "../../_App/Redux/Slices/product_marque/product_marque";
interface OptionType {
  value: string;
  label: string;
}
export default function InventaireForm({
  Inventaire,
  list_details_inventaire,
  ShowModal,
  setShowModal,
}: any) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const formOptions = {
    resolver: yupResolver(
      InventaireSchema,
    ) as unknown as Resolver<InventaireType>,
  };
  const {
    register,
    handleSubmit,
    reset,
    formState,
    getValues,
    setValue,
    watch,
  } = useForm<InventaireType>(formOptions);
  const { errors } = formState;
  const [selectedorganisation, setselectedorganisation] = useState("");
  const [search_article, setsearch_article] = useState(true);
  const [importExcel, setimportExcel] = useState(false);
  const [file, setfile] = useState<File | undefined>();
  const [listdepotsfilter, setlistdepots] = useState<DepotsType[]>([]);
  const [list_details, setlist_details] = useState<any[]>([]);
  const [selecteddepots, setselecteddepots] = useState<any>("");
  const parametrage = useAppSelector(parametrageCaisse);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout>();

  const TypeInputParametrage = parametrage?.SearchCaisse;

  const [TypeInput, setTypeInput] = useState(TypeInputParametrage);

  const listdOrganisations = useAppSelector(SelectedOrganisations);
  const listDepots = useAppSelector(ListDepots);
  const societe = useAppSelector(societeId);
  const listDepotByOrganisation = useAppSelector(ListDepotByOrganisation);
  const user = useAppSelector(selectUserId);
  const list_inventaire_details = useAppSelector(Liststockinventaire);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [date_inventaire, setdate_inventaire] = useState("");
  //******************** */
  const depotsRef = useRef<HTMLInputElement | null>(null);
  const ArticleRef = useRef<HTMLInputElement | null>(null);
  const [ListReference, setListReference] = useState<any[]>();
  const [ShowModalListReference, setShowModalListReference] = useState(false);
  const [listIdRemoved, setlistIdRemoved] = useState<any[]>([]);
  const [errMsg, setErrMsg] = useState("");
  const parametrage_caisse = useAppSelector(parametrageCaisse);
  const [titre, setTitre] = useState("");
  const [loading, setLoading] = useState(false);
  /***********************filtre marque/famille******** */
  const [selectedFamilles, setSelectedFamilles] = useState([]);
  const [selectedMarques, setSelectedMarques] = useState([]);
  const listProductMarque = useAppSelector(ListProductMarques);
  const listSousCategories = useAppSelector(ListSousCategories);
  const [ref1, setRef1] = useState("");
  const [ref2, setRef2] = useState("");

  const optionsFamille: any = listSousCategories.map((item) => ({
    value: item._id.toString(),
    label: item.libelle?.fr || item.libelle,
  }));

  const optionsMarque: any = listProductMarque.map((item) => ({
    value: item._id.toString(),
    label: item.libelle?.fr || item.libelle,
  }));

  useEffect(() => {
    if (societe) {
      dispatch(findSousCategorieBySociete(societe));
      dispatch(findProductsMarquesApiBySociete(societe));
    }
  }, [societe]);

  const handleFamilleChange = (newValue: any) => {
    if (Inventaire) {
      // Empêcher la suppression
      if (newValue.length < selectedFamilles.length) {
        return;
      } else {
        setSelectedFamilles(newValue);
      }
    } else {
      setSelectedFamilles(newValue);
    }
  };

  const handleMarqueChange = (newValue: any) => {
    const value = newValue || [];

    if (Inventaire) {
      if (value.length < selectedMarques.length) {
        return;
      }

      setSelectedMarques(value);
    } else {
      setSelectedMarques(value);
    }
  };

  /********************************** */
  useEffect(() => {
    setTimeout(() => {
      depotsRef.current?.focus();
    }, 0);
  }, []);
  useEffect(() => {
    if (Inventaire && list_details_inventaire) {
      reset({
        depots_id: Inventaire.depots_id._id,
        date_fin: Inventaire?.date_fin,
        date_debut: Inventaire?.date_debut,
      });
      setselecteddepots(Inventaire.depots_id);
      setTitre(Inventaire?.titre || "");
      setlist_details([...list_details_inventaire]);
    }
  }, [Inventaire, list_details_inventaire]);
  useEffect(() => {
    if (Inventaire) {
      const findlistMarque = optionsMarque.filter((i: any) =>
        Inventaire.listmarques.map((m: any) => m._id).includes(i.value),
      );

      setSelectedMarques(findlistMarque);

      const findlistFamille = optionsFamille.filter((i: any) =>
        Inventaire.listfamilles.map((m: any) => m._id).includes(i.value),
      );
      setSelectedFamilles(findlistFamille);
      setRef1(Inventaire.ref1);
      setRef2(Inventaire.ref2);
    }
  }, [Inventaire]);

  useEffect(() => {
    setTypeInput(TypeInputParametrage);
  }, [TypeInputParametrage]);

  useEffect(() => {
    if (societe) {
      dispatch(findDepotsBySocieteApi(societe));
    }
  }, [societe]);
  useEffect(() => {
    setlist_details([...list_details, ...list_inventaire_details]);
  }, [list_inventaire_details]);
  useEffect(() => {
    if (!selectedorganisation) {
      setlistdepots(listDepots);
    } else {
      const list = listDepotByOrganisation[selectedorganisation];
      if (list) {
        const sortedList = [...list].sort((a, b) => {
          if (a.defaut === b.defaut) {
            return 0;
          } else if (a.defaut === true) {
            return -1;
          } else {
            return 1;
          }
        });
        setValue("depots_id", sortedList[0]?._id || "");

        setlistdepots(sortedList);
        setselecteddepots(sortedList[0]?._id || "");
      } else {
        setlistdepots([]);
      }
    }
  }, [selectedorganisation]);

  const Enregistrer = async () => {
    const resverification = await verifcationMsg();
    if (resverification) {
      if (importExcel) {
        ImportExcelFunction();
      } else {
        saveInventaire();
      }
    }
  };

  const verifcationMsg = () => {
    return Swal.fire({
      title: t("vous-êtes sûr?"),
      text: `${t("vous voulez")} ${
        Inventaire ? t(`modifier  `) : t(`enregistrer  `)
      }${t("  cet inventaire")} `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Confirmer!"),
      cancelButtonText: t("Cancel!"),
    }).then((result) => {
      return result.isConfirmed ? true : false;
    });
  };
  const saveInventaire = async () => {
    let data: any = {};
    data.depots_id =
      selecteddepots !== "" ? selecteddepots?._id : listdepotsfilter[0]?._id;
    const newlist_details = list_details.map((element) => ({
      ...element,
      article_id: element.article?._id,
    }));
    let data_inventaire: any = {
      code_inventaire: Inventaire ? Inventaire.code_inventaire : "",
      depots_id: data.depots_id,
      societe_id: societe || null,

      organisation_id:
        selecteddepots !== "" ? selecteddepots?.organisation_id : null,
      type: "inventaire_stock",
      cloture: false,
      annuler: false,
      confirmer: false,
      user: user,
      details: newlist_details,
      listmarques: selectedMarques.map((a: any) => a.value),
      listfamilles: selectedFamilles.map((a: any) => a.value),
      ref1,
      ref2,
      titre: titre,
    };
    let response;
    if (Inventaire) {
      data_inventaire = { ...data_inventaire, _id: Inventaire._id };
      response = await dispatch(
        updateInventaireDetailsApi({
          data: data_inventaire,
          listIds: listIdRemoved,
        }),
      );
    } else {
      /// create
      response = await dispatch(createInventaireApi(data_inventaire));
    }
    if (response?.payload.success) {
      ToastSuccess(response?.payload.message);
      setlist_details([]);

      window.location.reload();
    } else {
      ToastWarning(response?.payload.message);
    }
  };

  const ImportExcelFunction = async () => {
    if (file) {
      const data = {
        file: file,
        organisation_id: selectedorganisation,
        depots_id: selecteddepots,
        societe_id: societe,
        user: user,
      };
      const response = await dispatch(importInventaireExcelApi(data));
      if (response?.payload.success) {
        if (response.payload.datareturn.length !== 0) {
          await alertArticleNotFound(response.payload.datareturn);
        } else {
          ToastSuccess(response?.payload.message);

          window.location.reload();
        }
      } else {
        ToastWarning(response?.payload.message);
      }
    } else {
      ToastWarning("choisir un fichier excel ");
    }
  };

  const alertArticleNotFound = async (list: any) => {
    let tableContent = `
      <table class='table'>
        <thead>
        <tr>${list.length}<tr>
          <tr>
            <th>INDEX</th>
            <th>Code Article</th>
            <th>Code à barre</th>
            <th>Stock</th>
          </tr>
        </thead>
        <tbody>
          ${list
            .map(
              (item: any) => `
            <tr>
              <td>${item.index}</td>
              <td>${item.code_article}</td>
              <td>${item.code_a_barre}</td>
              <td>${item.stock}</td>
            </tr>
          `,
            )
            .join("")}
        </tbody>
      </table>
    `;

    Swal.fire({
      icon: "error",
      title: "Oops...Articles introuvables !",
      html: tableContent,
      willClose: () => {
        // Reload the page when the SweetAlert is closed
        window.location.reload();
      },
    });
  };
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const lastKeyPressTime = useRef<number>(0);
  const handleChange = (event: any) => {
    const { value } = event.target;
    setSearchTerm(value);

    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    const isScannerInput = timeDiff < 50;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(
      async () => {
        if (value !== "" || isScannerInput) {
          setSearchTerm(value);
          await findArticle(value);
        }
      },
      isScannerInput ? 100 : 2000,
    );
  };
  /****depot scan */
  const removeOrg = () => {
    setselecteddepots("");
  };

  const handleInputChange = async (code: string) => {
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    // Si le temps entre deux entrées est court, c'est probablement un scan
    const isScannerInput = timeDiff < 50;
    if (timeoutId) clearTimeout(timeoutId);
    const newTimeoutId = setTimeout(
      async () => {
        setLoading(true);
        await findDepotBycode(code);
      },
      isScannerInput ? 100 : 2000,
    );

    setTimeoutId(newTimeoutId);
  };

  const findDepotBycode = async (code: string) => {
    const resp = await dispatch(findDepotsByCodeApi(code));
    if (resp.payload.success) {
      setselecteddepots(resp.payload.data);
      ArticleRef.current?.focus();
    } else {
      ToastWarning(resp.payload.message);
    }

    setLoading(false);
  };

  const findArticle = async (codeabarre: string) => {
    if (selecteddepots !== "") {
      setLoading(true);
      const data = {
        codeArticle: encodeURIComponent(codeabarre),
        TypeInput,
        depots: selecteddepots?._id,
        organisation_id: selecteddepots?.organisation_id,
        societe,
        marque: JSON.stringify(selectedMarques.map((a: any) => a.value)),
        famille: JSON.stringify(selectedFamilles.map((a: any) => a.value)),
        ref1: ref1,
        ref2: ref2,
      };

      const resultArticle = await dispatch(
        CalculStockInventaireArticleApi(data),
      );

      if (resultArticle.payload.success && resultArticle.payload.data[0]) {
        if (TypeInput === "codeBarre") {
          await addItemToList(resultArticle.payload.data[0]);
        } else {
          setListReference(resultArticle.payload.data);
          setShowModalListReference(true);
        }
        setErrMsg("");

        setSearchTerm("");
      } else {
        console.log(resultArticle.payload.message);
        ToastDanger(resultArticle.payload.message || "l'article n'existe pas");
        setErrMsg(resultArticle.payload.message || "l'article n'existe pas");
        setSearchTerm("");
      }

      setLoading(false);
    } else {
      ToastWarning("entrer le code  depots ");
      setSearchTerm("");
    }
  };
  const removeitem = (item: any) => {
    setlist_details(
      list_details.filter((a) => a?.article?._id !== item?.article?._id),
    );
    if (item && item?._id) {
      setlistIdRemoved((prev) => [...prev, item._id]);
    }
  };

  const addItemToList = async (item: any) => {
    setShowModalListReference(false);
    setSearchTerm("");

    const findarticle = list_details.findIndex(
      (e) => e.article._id === item.article._id,
    );

    if (findarticle === -1) {
      const obj = {
        ...item,
        quantite: 1,
      };
      setlist_details((prev) => [obj, ...prev]);
      setSearchTerm("");
    } else {
      setlist_details((prevList) => {
        const newList = [...prevList];
        const item = {
          ...newList[findarticle],
          quantite: newList[findarticle].quantite + 1,
        };

        // Retirer l’article de sa position actuelle
        newList.splice(findarticle, 1);
        // Le remettre en tête
        newList.unshift(item);

        return newList;
      });

      setSearchTerm("");
    }
  };
  const ExportFichier = () => {
    const path_server = process.env.REACT_APP_API_UPLOADS_URL;
    const url = `${path_server}FicherTelecharger/inventaire.xlsx`;
    window.open(url, "_blank");
  };
  const calculTotal = list_details
    ? list_details.reduce(
        (sum: any, item: any) => sum + (item.quantite || 0),
        0,
      )
    : 0;

  const handelChangeRef = (ref: string, value: string) => {
    if (list_details.length > 0) {
      setErrMsg(
        "Vous ne pouvez pas changer le filtre car deja des acrticle scanee ",
      );
    } else {
      setErrMsg("");

      if (ref === "ref1") {
        setRef1(value);
      } else {
        setRef2(value);
      }
    }
  };
  return (
    <div>
      <Modal
        show={ShowModal}
        className="modal-1"
        dialogClassName="modal-90w"
        backdropClassName="modal-backdrop-1"
      >
        <Modal.Header>
          <Modal.Title className="c-primary">
            {" "}
            <span>{t("Inventaire")}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="container mt-4 ">
            <Form.Check // prettier-ignore
              type="switch"
              id="custom-switch"
              label="Import Excel" //chercher par code a barre ou code article
              checked={importExcel}
              onClick={() => setimportExcel(!importExcel)}
            />

            <div className="row mb-3 ">
              {!importExcel ? (
                <>
                  <div className="col-3">
                    <strong>{t("Familles")}</strong>
                    <Select
                      isMulti
                      options={optionsFamille}
                      value={selectedFamilles}
                      onChange={handleFamilleChange}
                      placeholder="Sélectionner familles"
                    />
                  </div>

                  <div className="col-3">
                    <strong>{t("Marques")}</strong>
                    <Select
                      isMulti
                      options={optionsMarque}
                      value={selectedMarques}
                      onChange={handleMarqueChange}
                      placeholder="Sélectionner  marques"
                    />
                  </div>
                  <div className="col-3">
                    <strong>{t("Ref 1")}</strong>
                    <input
                      type="text"
                      className="form-control "
                      value={ref1}
                      onChange={(e) => handelChangeRef("ref1", e.target.value)}
                    />
                  </div>
                  <div className="col-3">
                    <strong>{t("Ref 2")}</strong>
                    <input
                      type="text"
                      className="form-control "
                      value={ref2}
                      onChange={(e) => handelChangeRef("ref2", e.target.value)}
                    />
                  </div>
                  <div className="col-4">
                    <strong>{t("Depots   : ")}</strong>
                    {selecteddepots === "" ? (
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => {
                          handleInputChange(e.target.value);
                        }}
                        ref={depotsRef}
                      />
                    ) : (
                      <>
                        <span className="form-control">
                          {selecteddepots?.libelle}
                          <i
                            onClick={() => removeOrg()}
                            className="fas fa-times"
                          ></i>
                        </span>
                      </>
                    )}
                  </div>
                  <div className="col-4">
                    <strong>{t("commentaire")}</strong>
                    <input
                      type="text"
                      className="form-control "
                      value={titre}
                      onChange={(e) => setTitre(e.target.value)}
                    />
                  </div>
                  <div className="col-4  ">
                    <div className="form-group">
                      <strong>{t("Article ")}</strong>
                      <input
                        type="text"
                        className="form-control "
                        value={searchTerm}
                        ref={ArticleRef}
                        onChange={handleChange}
                      />
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "60%",
                        transform: "translateY(-60%)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {TypeInput === "codeBarre" ? (
                        <span
                          className="form-control btn-primary"
                          onClick={() => setTypeInput("ref")}
                          style={{
                            width: "60px",
                            height: "40px",
                          }}
                        >
                          CB
                        </span>
                      ) : (
                        <span
                          className="form-control  btn-primary"
                          onClick={() => setTypeInput("codeBarre")}
                          style={{
                            width: "60px",
                            height: "40px",
                          }}
                        >
                          REF
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-1">
                    {loading && (
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ width: "3rem", height: "3rem" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    )}
                  </div>
                  <div
                    className="text-center"
                    style={{
                      fontWeight: "bolder",
                      color: "red",
                      fontSize: "20px",
                    }}
                  >
                    {errMsg}
                  </div>
                  <div
                    className="text-center"
                    style={{
                      fontWeight: "bolder",
                      color: "blue",
                      fontSize: "20px",
                    }}
                  >
                    {t("Quantité totale scannée")} {calculTotal}
                  </div>
                </>
              ) : (
                <>
                  <div className="col-4">
                    <strong>{t("Depots   : ")}</strong>
                    {selecteddepots === "" ? (
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => {
                          handleInputChange(e.target.value);
                        }}
                        ref={depotsRef}
                      />
                    ) : (
                      <>
                        <span className="form-control">
                          {selecteddepots?.libelle}
                          <i
                            onClick={() => removeOrg()}
                            className="fas fa-times"
                          ></i>
                        </span>
                      </>
                    )}
                  </div>
                  <div className="col-md-2   ">
                    <div className="form-group">
                      <label htmlFor="date_debut">{t("date debut")}</label>
                      <input
                        className={`form-control ${
                          errors.date_debut ? "is-invalid" : ""
                        }`}
                        type="date"
                        id="date_debut"
                        {...register("date_debut")}
                      />
                    </div>
                  </div>
                  <div className="col-md-2   ">
                    <div className="form-group">
                      <label htmlFor="date_fin">{t("date date_fin")}</label>
                      <input
                        className={`form-control ${
                          errors.date_fin ? "is-invalid" : ""
                        }`}
                        type="date"
                        id="date_fin"
                        {...register("date_fin")}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group ">
                      <label htmlFor="depot_id ">
                        <span style={{ color: "red" }}></span>
                        {t("dernier inventaire")}
                      </label>
                      <input
                        className={`form-control ${
                          errors.date_fin ? "is-invalid" : ""
                        }`}
                        type="date"
                        id="date_fin"
                        onChange={(e) => setdate_inventaire(e.target.value)}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {!importExcel && (
            <div className="row">
              <InventaireDetail
                t={t}
                list_details={list_details}
                setlist_details={setlist_details}
                removeitem={removeitem}
                parametrage_caisse={parametrage_caisse}
              />
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            type="reset"
            onClick={(e) => setShowModal(false)}
            className="btn btn-primary-app"
          >
            {t("Annuler")}
          </button>
          <button onClick={Enregistrer} className="btn btn-primary-app">
            {t("Enregistrer")}
          </button>
        </Modal.Footer>
      </Modal>
      <ArticleListReference
        t={t}
        ShowModal={ShowModalListReference}
        setShowModal={setShowModalListReference}
        selectAricle={addItemToList}
        list={ListReference}
        reference={searchTerm}
      />
    </div>
  );
}
